module.exports = __webpack_public_path__ + "static/media/image-everything-you-need-to-know.e04dd3ac.png";